// import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import useContextHook from "./useContext";

const InvestorOTPPrivateRoute = ({ Component }: any) => {
  const { mobileNumber } = useContextHook();
  return mobileNumber.length > 0 ? (
    <Component />
  ) : (
    <Navigate to="/investor-login" />
  );
};

export default InvestorOTPPrivateRoute;
